import styled from 'styled-components';

const BackgroundGradient = styled.div`
  width: 100%;
  background-image: linear-gradient(to bottom, #e0e8ff 0%, white 95%);
  overflow-x: hidden;
`;

export default BackgroundGradient;
